import { graphql } from '~/lib/graphql'

export const GetInventoryOnlySeat = graphql(`
  query getInventoryOnlySeat(
    $restaurantId: RestaurantId!
    $visitorsCount: Int!
    $visitDate: Date!
    $visitTime: HourMinute!
  ) {
    restaurant(restaurantId: $restaurantId) {
      inventory(visitDate: $visitDate, visitorsCount: $visitorsCount, visitTime: $visitTime) {
        seatOnlyPlans {
          plan {
            ...PlanSelectionInfo
          }
        }
      }
    }
  }
`)
